import { useOptionalUser } from '#hooks/useUser.tsx'
import { ButtonLink } from '#ui/ButtonLink.tsx'
import { HeaderRoot } from '#ui/HeaderRoot.tsx'
import { NavLink } from '#ui/NavLink.tsx'

export default function Header(props: { hideButtons?: boolean }) {
  const user = useOptionalUser()

  return (
    <HeaderRoot>
      {props.hideButtons ? null : user ? (
        // Force a document reload here so that Sentry loads/unloads
        <nav className='flex items-center gap-4'>
          <NavLink to='/pricing'>Pricing</NavLink>
          <ButtonLink to='/app'>Dashboard</ButtonLink>
        </nav>
      ) : (
        <nav className='flex items-center gap-4'>
          <NavLink to='/pricing'>Pricing</NavLink>
          <ButtonLink theme='primary' to='/join'>
            Sign up now
          </ButtonLink>
          <ButtonLink theme='subtle' to='/login'>
            Log In
          </ButtonLink>
        </nav>
      )}
    </HeaderRoot>
  )
}
